// extracted by mini-css-extract-plugin
export default {"modal":"UpdatePasswordModal_modal__Masoo","form":"UpdatePasswordModal_form__xnj9u","formItem":"UpdatePasswordModal_formItem__sEhxi"};